<template>
    <headboard></headboard>
    <div class="" style="padding-left:5%;padding-right:5%;">
        <div class="row mt-5">
            <div class="col-sm-12 modspec_font16-700">
                Add and standardise your construction options to suit the Section J requirements of the commercial
                building code!
            </div>
        </div>
        <div class="row ">
            <div class="col-sm-12 modspec_font10">
                Client / Add Construction Detail
            </div>
        </div>
        <div class="row ">
            <div class="col-sm-6">
                <newConstruction :idCliente="idClient"/>
            </div>
        </div>

    </div>
</template>
<script>
import header from "../components/header.vue"
import newConstruction from "../../components/quote/new-construction.vue";

import { useRoute } from "vue-router";
export default {

    name: 'construction-page',
    data: function () {
        return {
            idClient: 0
        }
    },
    components: {
        'headboard': header,
        'newConstruction': newConstruction,
    },
    methods: {

    },
    mounted() {
        const route = useRoute()
        let id = route.params.id
       
        if (id != null) this.idClient = id;

    }
}
</script>
<style></style>